import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useLeftBar } from "../../context/LeftBar";
import NavItem from "./MenuItem/NavItem";

import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";
import ContactSupportOutlinedIcon from "@mui/icons-material/ContactSupportOutlined";
import QueryStatsIcon from "@mui/icons-material/QueryStats";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";

import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import SummarizeOutlinedIcon from "@mui/icons-material/SummarizeOutlined";

import styles from "../LeftSideMenu/styles.css";

function LeftSideMenu({ app, config, logo }) {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [dataAtualizacao, setDataAtualizacao] = useState("");

  async function initialSelecao() {
    await app.variable.getContent("vAtualizacao", (reply) => {
      const data = reply.qContent.qString;
      setDataAtualizacao(data.substring(0, 10));
    });
  }

  useEffect(() => {
    initialSelecao();
    window.addEventListener("resize", () => setScreenWidth(window.innerWidth));

    return () => {
      window.removeEventListener("resize", () =>
        setScreenWidth(window.innerWidth)
      );
    };
  }, []);

  const { leftBarOpened, setLeftBarOpened } = useLeftBar();
  return (
    <div
      className={
        leftBarOpened ? "leftSideMenu is-opened" : "leftSideMenu  is-closed"
      }
    >
      <div className="leftSideHeader">
        <button
          type="button"
          onClick={() => {
            setLeftBarOpened(!leftBarOpened);
          }}
          className={leftBarOpened ? "button-menu" : "button-menu align-left"}
        >
          {leftBarOpened ? <ArrowBackIcon /> : <ArrowForwardIcon />}
        </button>
      </div>

      <div className="leftSideContent">
        {leftBarOpened && (
          <h3 className="leftSideContentTitle"> SCORECARD 3PD </h3>
        )}
        <ul>
          <NavItem
            muiIcon={<QueryStatsIcon />}
            name="Visitas"
            path="/overview"
          />
        </ul>
        <ul>
          <NavItem
            muiIcon={<SummarizeOutlinedIcon />}
            name="Relatórios"
            path="/reports"
          />
        </ul>
        <ul>
          <NavItem muiIcon={<CurrencyExchangeIcon />} name="Vendas" path="/" />
        </ul>

        {leftBarOpened && <h3 className="leftSideContentTitle">AJUDA</h3>}
        {/* <ul>
          <NavItem
            muiIcon={<DescriptionOutlinedIcon />}
            name="Regras da Campanha"
            path="/"
          />
        </ul> */}
        <ul>
          <NavItem
            muiIcon={<ContactSupportOutlinedIcon />}
            name="Perguntas Frequentes"
            path="/"
          />
        </ul>
      </div>
    </div>
  );
}

LeftSideMenu.defaultProps = {
  app: null,
  config: null,
  logo: null,
};

LeftSideMenu.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
  logo: PropTypes.object,
};

export default LeftSideMenu;
